import { httpClient } from '@/services/http/httpClient'

import type { GetTaskResponse } from '../getTask'

type GetTasksProps = {
  projectId: string
}

export async function getTasks({
  projectId,
}: GetTasksProps): Promise<GetTaskResponse[]> {
  const { data } = await httpClient.get<GetTaskResponse[]>(
    `/projects/project-tasks/list/${projectId}`,
  )
  return data
}
